export const VISIBLE_VES_BANKS = ['0169', '0171', '0138'];

export function isVisibleVesBank(walletId: unknown): boolean {
  return VISIBLE_VES_BANKS.includes(String(walletId ?? '').trim());
}

